import * as React from "react";
import { UseFormReturn, SubmitHandler } from "react-hook-form";

const useExposeFormApi = (
  ref: React.ForwardedRef<any>,
  formMethods: UseFormReturn<any>,
  onFormSubmit: SubmitHandler<any>
) => {
  React.useImperativeHandle(ref, () => ({
    isValid: async () => {
      return await formMethods.trigger();
    },
    submit: async () => {
      return await formMethods.handleSubmit(onFormSubmit)();
    },
  }));
};

export default useExposeFormApi;
